import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/app";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth/authConfig";
import { removeToken, storeToken } from "./utils/auth";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

function getCspNonce(): string | undefined {
  const meta = document.querySelector('meta[name="csp-nonce"]');
  return meta?.getAttribute("content") || (window as any).__CSP_NONCE_VAL__;
}

const muiCache = createCache({
  key: "mui",
  nonce: getCspNonce(),
  prepend: true,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: any) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
  ) {
    storeToken(event.payload.accessToken);
  } else if (event.eventType === EventType.LOGOUT_START) {
    removeToken();
  }
});

root.render(
  <CacheProvider value={muiCache}>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>
  </CacheProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
